import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from 'types/Reducers';

interface IState {
  snackbarMessage: string | null;
  tracking: {
    advertClick: boolean;
  }
};

const initialState:IState = {
  snackbarMessage: null,
  tracking: {
    advertClick: false
  }
};

const slice = createSlice({
  name: Reducers.UI,
  initialState,
  reducers: {
    setSnackbarMessage: (state, action:PayloadAction<string | null>) => {
      state.snackbarMessage = action.payload;
    },
    setTrackingAdvertClick: (state) => {
      state.tracking.advertClick = true
    }
  },
  extraReducers(builder) {
    
  }
});

export const { setSnackbarMessage, setTrackingAdvertClick } = slice.actions;

export default slice.reducer;
